export const FoxitSign = {
  "RequestSignature": {
    "Intro": {
      "title": "Foxit Sign keep work moving",
      "describe": "Automate your workflows with Foxit Sign to improve customer experience, strengthen compliance, and eliminate costs related to paper-based processes.",
      "licenseRequired": "A license is required to use the Foxit eSign features. If you already have a Foxit Sign subscription, sign in to your account or contact your IT administrator to gain license.",
      "cancel": "Cancel",
      "signIn": "Sign in"
    },
    "Remind": {
      "title": "Thank you for your interest in Foxit Sign!",
      "subscribeExpired": "Your subscription has expired. Subscribe now.",
      "subscribeExpiredEnterprise": "Your subscription has expired.<br/> Please contact your IT Administrator to gain access.",
      "trialExpired": "The free trial period for this account has expired. Subscribe now.",
      "noEnvelope": "You have no envelopes remaining. Subscribe now.",
      "noEnvelopeEnterprise": "You have no envelopes remaining. Please contact your IT Administrator to gain access.",
      "cancel": "Cancel",
      "close": "Close",
      "contactPhone": "Please contact us at: +1-866-680-3668(24/7)",
      "contactEmail": "Sales and Information: sales@foxitsoftware.com",
      "subscribeNow": "Subscribe Now"
    },
    "AddFiles": {
      "title": "Add files",
      "addFilesBtn": "Add files",
      "cancel": "Cancel",
      "upload": "Upload",
      "name": "Name",
      "modified": "Modified",
      "size": "Size",
      "saveFilePending": "The file is still being uploaded, are you sure you want to exit?",
      "cancelUpload": "Click OK to cancel uploading",
      "openFoxitSignMsg": "Files have been uploaded. Would like to open Foxit Sign webpage?",
      "uploadFail": "An unknown error occurred."
    },
    "Error": {
      "fileOverSize": "The file size cannot exceed {fileSize} MB.",
      "serverError": "The Foxit eSign service is temporarily unavailable, please try again later."
    }
  },
  "ESignSwitchAccounts": {
    "title": "Foxit eSign Accounts",
    "switchInfo": "Please select an account that you want to work with",
    "account": "Account",
    "Ok": "OK",
    "Cancel": "Cancel",
  }
}